// @ts-nocheck
import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Box,
  Button,
  CircularProgress,
  Typography,
  useMediaQuery,
} from "@mui/material";
import dayjs from "dayjs";

import {
  setSessionData,
  updateSessionStep1DataAction,
} from "../../../../../store/actions/createEvent";
import { sessionObjToFormObjHandler } from "../sessionHandlers";
import { getCssVariableHandler } from "../../../../../utils/styles/getCssVariables";

import EditIcon from "../../../../../assets/images/Edit-Square.svg";
import Star from "../../../../../assets/images/star.svg";
import DeletePink from "../../../../../assets/images/Delete-pink.svg";

import { CustomDialog } from "../../../../../components/Dialog/CustomDialog";
import { OpenInNew } from "@mui/icons-material";
import { getUniversalDateTimeFormat } from "../../../../../utils/methods/universalDateTimeFormat";
import { CLEAR_SESSION_STEP_2_FORM } from "../../../../../store/constants/createEvent";
import CustomHelper from "../../../../../components/Helper/CustomHelper";
import _ from "lodash";

const SessionList = ({
  style,
  setStep,
  eventInfo,
  sessionsOfEvent,
  viewAllSessions,
  selectedSessionId,
  setEditSessionData,
  setSelectedSessionId,
  editSessionCallback,
  deleteSessionParentHandler,
  onClickGivenSessionHandler,
  toBeDeletedSession,
  setToBeDeletedSession,
  deleteSessionLoading,
  setDeleteSessionLoading,
  confirmPassword,
  setConfirmPassword,
  readOnly,
  showNewModalIcon,
  onNewModalClick,
}) => {
  // redux-hooks start...
  const dispatch = useDispatch();
  // redux-hooks end...

  // media query hooks start...
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const actionButtonsBreakpoint = useMediaQuery(
    "(min-width:1195px) and (max-width:1400px)",
  );
  // media query hooks end...

  // Selectors start...
  const auth = useSelector((store) => store.auth);
  // const sessionsOfEvent = useSelector((store) => store.createContactInfo.sessionsOfEvent);
  // const eventInfo = useSelector((state) => state.createContactInfo.eventInfo);
  // Selectors end...

  const data = sessionsOfEvent?.map?.((session) => {
    return {
      ...session,
      totalShifts: session.position
        ?.map((item) =>
          item.positionData?.map((el) => ({
            ...el,
            positionId: item.positionId,
          })),
        )
        .flat()?.length,
      totalPositions: _.uniqBy(session?.position, "positionId")?.length,
    };
  });

  // State variables start...
  // const [toBeDeletedSession, setToBeDeletedSession] = useState(null);
  const [deleteId, setDeleteId] = useState("");

  // const [deleteSessionLoading, setDeleteSessionLoading] = useState(false);
  // State variables end...

  // Handlers start...
  const setupDeleteSessionHandler = (toBeDeletedSession) => {
    setToBeDeletedSession(toBeDeletedSession);
  };

  const cancelDeleteSessionHandler = () => {
    setToBeDeletedSession(null);
  };

  const deleteSessionCallback = () => {
    setDeleteSessionLoading(false);
    setToBeDeletedSession(null);
    if (sessionsOfEvent?.[0]) {
      setSelectedSessionId(sessionsOfEvent?.[0]?._id);
      dispatch(
        updateSessionStep1DataAction({
          payload: {
            sessionStep1: sessionsOfEvent?.[0],
            sessionStep1Form: sessionObjToFormObjHandler({
              session: sessionsOfEvent?.[0],
              eventInfo,
            }),
            sessionStep1PreviouslySubmittedForm: sessionObjToFormObjHandler({
              session: sessionsOfEvent?.[0],
              eventInfo,
            }),
          },
        }),
      );
    }
  };

  const deleteSessionFailureCallback = () => {
    setDeleteSessionLoading(false);
    setToBeDeletedSession(null);
  };

  const deleteSessionHandler = () => {
    // MOVE THIS LOGIC TO THE PARENT COMPONENT....
    // const afterSuccess = () => {
    //     dispatch(getSessionssOfSpecificEvent(eventInfo?._id));
    //     setToBeDeletedSession(null);
    //     setDeleteSessionLoading(false);
    //     // deleteSessionCallback ? deleteSessionCallback(toBeDeletedSession?._id) : null;
    // }

    // dispatch(deleteSessionAction({
    //     sessionId: toBeDeletedSession?._id, successCallback: afterSuccess,
    //     auth: eventInfo?.userId ? auth : null
    // }));

    // setDeleteSessionLoading(true);

    deleteSessionParentHandler({
      deleteSessionCallback,
      deleteSessionFailureCallback,
    });
  };
  // Handlers end...

  return (
    <>
      <Box
        sx={{
          flex: "0 0 500px",
          width: style?.width || "500px",
          margin: "0 auto 10px auto",
          borderRadius: "12px",
          padding: "16px",
          border: "1px solid #D175B6",
          background: "#000",
          boxShadow: "0px 0px 30px 0px rgba(255, 255, 255, 0.20)",
          height: "fit-content",
          "& > div + div": {
            marginTop: "16px",
          },
          "& > div": {
            padding: "16px",
          },
          "@media (max-width: 600px)": {
            width: "100%",
          },
        }}
      >
        {data?.length > 0 ? (
          data?.map((item, index) => {
            return (
              <Box
                key={index}
                sx={{
                  padding: "16px",
                  borderRadius: "12px",
                  cursor: "pointer",
                  border: "1px solid #D175B6",
                  display: "flex",
                  flexDirection:
                    isSmallScreen || actionButtonsBreakpoint ? "column" : "row",
                  justifyContent: "space-between",
                  alignItems:
                    isSmallScreen || actionButtonsBreakpoint
                      ? "space-between"
                      : "center",
                }}
                onClick={(e) => {
                  // dispatch(updateSessionStep1DataAction({
                  //     payload: {
                  //         sessionStep1Form: sessionObjToFormObjHandler({
                  //             session: item
                  //         }),
                  //         sessionStep1: item
                  //     }
                  // }));
                  // setStep(1);
                  // NOTE: logic

                  setEditSessionData ? setEditSessionData?.(item) : null;
                  dispatch(
                    updateSessionStep1DataAction({
                      payload: {
                        sessionStep1Form: sessionObjToFormObjHandler({
                          session: item,
                          eventInfo,
                        }),
                        sessionStep1PreviouslySubmittedForm:
                          sessionObjToFormObjHandler({
                            session: item,
                            eventInfo,
                          }),
                        sessionStep1: item,
                      },
                    }),
                  );
                  dispatch({
                    type: CLEAR_SESSION_STEP_2_FORM,
                  });
                  dispatch(
                    setSessionData({
                      session: item,
                    }),
                  );

                  onClickGivenSessionHandler(e, item);
                }}
                className={`${viewAllSessions || selectedSessionId === item?._id ? "active-room" : ""}`}
              >
                <Box>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      flexWrap: "wrap",
                    }}
                  >
                    <Typography
                      variant="h4"
                      sx={{
                        fontSize: "20px",
                        color: "#ffffff",
                        display: "flex",
                        alignItems: "center",
                        marginRight: "10px",
                        "& img": {
                          marginLeft: "10px",
                        },
                      }}
                    >
                      {item.sessionName}
                      {!isSmallScreen ? <img src={Star} /> : null}
                    </Typography>
                    <Typography
                      sx={{
                        color: `${viewAllSessions || selectedSessionId === item?._id ? "white" : "#D175B6"}`,
                      }}
                    >
                      {item?.totalPositions}{" "}
                      {item?.totalPositions > 1 ? "Positions" : "Position"} -
                      {item?.totalShifts}{" "}
                      {item?.totalShifts > 1 ? "Shifts" : "Shift"}
                    </Typography>
                  </Box>
                  {isSmallScreen ? (
                    <Typography sx={{ fontSize: "12px", marginTop: "5px" }}>
                      {`${dayjs(item.sessionStart).format("DD MMM, YYYY")} - ${dayjs(item.sessionEnd).format("DD MMM,YYYY")}`}
                    </Typography>
                  ) : (
                    <Typography
                      sx={{
                        fontSize: "12px",
                        marginTop: "5px",
                        wordBreak: "break-all",
                      }}
                    >
                      {`Start from ${
                        getUniversalDateTimeFormat({
                          dateTime: item?.sessionStart,
                        }) || item?.sessionStart
                      } - Ends at ${
                        getUniversalDateTimeFormat({
                          dateTime: item?.sessionEnd,
                        }) || item?.sessionEnd
                      }`}
                    </Typography>
                  )}
                </Box>
                <Box
                  sx={{
                    marginTop: "10px",
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    flexWrap: "wrap",
                    gap: "10px",
                  }}
                >
                  {showNewModalIcon ? (
                    <Button
                      variant="text"
                      sx={{
                        backgroundColor: "white",
                        width: "2rem",
                        height: "2rem",
                        minWidth: "auto",
                        ":hover": {
                          backgroundColor: "white",
                          boxShadow: `0px 30px 80px 0px rgba(255, 0, 255, 0.30), 0px 0px 20px 0px ${getCssVariableHandler({ variableName: "--primary-pink-rgb" })} inset`,
                        },
                      }}
                      onClick={(e) => {
                        e?.stopPropagation();
                        // setStep(1);
                        onNewModalClick(item);
                      }}
                    >
                      <OpenInNew />
                    </Button>
                  ) : null}
                  {!readOnly?.editSession ? (
                    <CustomHelper message={"Edit session"} index={index}>
                      <Button
                        variant="text"
                        sx={{
                          backgroundColor: "#C369A7",
                          padding: "10px 10px",
                          width: "auto",
                          minWidth: "auto",
                          ":hover": {
                            backgroundColor: "#C369A7",
                          },
                        }}
                        onClick={(e) => {
                          e?.stopPropagation();
                          // setStep(1);
                          setEditSessionData
                            ? setEditSessionData?.(item)
                            : null;
                          dispatch(
                            updateSessionStep1DataAction({
                              payload: {
                                sessionStep1Form: sessionObjToFormObjHandler({
                                  session: item,
                                  eventInfo,
                                }),
                                sessionStep1PreviouslySubmittedForm:
                                  sessionObjToFormObjHandler({
                                    session: item,
                                    eventInfo,
                                  }),
                                sessionStep1: item,
                              },
                            }),
                          );
                          dispatch({
                            type: CLEAR_SESSION_STEP_2_FORM,
                          });
                          dispatch(
                            setSessionData({
                              session: item,
                            }),
                          );
                          editSessionCallback ? editSessionCallback(e) : null;
                        }}
                      >
                        <img src={EditIcon} alt="" />
                      </Button>
                    </CustomHelper>
                  ) : null}
                  {!readOnly?.deleteSession ? (
                    <CustomHelper message={"Delete session"} index={index}>
                      <Button
                        size="small"
                        variant="text"
                        sx={{
                          backgroundColor: "#fff",
                          padding: "10px 10px",
                          width: "auto",
                          minWidth: "auto",
                          ":hover": {
                            backgroundColor: "#fff",
                          },
                        }}
                        onClick={(e) => {
                          e?.stopPropagation();
                          setupDeleteSessionHandler(item);
                          // handleDeleteSession(item._id, deleteSessionCallback);
                        }}
                      >
                        {deleteSessionLoading && deleteId === item?._id ? (
                          <CircularProgress
                            size={22}
                            style={{
                              color: "black",
                            }}
                          />
                        ) : (
                          <img src={DeletePink} alt="" />
                        )}
                      </Button>
                    </CustomHelper>
                  ) : null}
                </Box>
              </Box>
            );
          })
        ) : (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography>No sessions</Typography>
          </Box>
        )}
      </Box>
      {/* <Modal
                open={Boolean(toBeDeletedSession?._id)}
                onClose={cancelDeleteSessionHandler}
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}
            > 
                <Box
                    sx={{
                    width: '70vw',
                    height: '70vh'
                    }}
                >
                    <ReusableParentContainer 
                        style={{
                            width: '100%',
                            height: '100%',
                            background: 'rgb(0, 0, 0)'
                        }}
                    >
                        <Box
                            sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            gap: '1.5rem'
                            }}
                        >
                            <Typography
                                variant="h4"
                            >
                                Are you sure you want to perform this action?
                            </Typography>

                            <Box 
                                className={styles.bottomBtn}
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '1rem'
                                }}
                            >
                            <Button
                                className={styles.BtnPosition}
                                onClick={() => {
                                    // submitForm();
                                    deleteSessionHandler();
                                }}
                                // sx={{
                                //   backgroundColor: `rgb(0, 0, 0) !important`
                                // }}
                            >
                                {deleteSessionLoading ? (
                                    <CircularProgress size={22} />
                                    ) : "Confirm"}
                            </Button>

                            <Button
                                className={styles.BtnPosition}
                                sx={{
                                    backgroundColor: `${getCssVariableHandler({
                                        variableName: `--primary-pink-hex`
                                    })} !important`
                                }}
                                onClick={() => {
                                    cancelDeleteSessionHandler();
                                }}
                            >
                                Cancel
                            </Button>
                            </Box>
                        </Box>
                    </ReusableParentContainer>
                </Box>
            </Modal> */}
      <CustomDialog
        open={Boolean(toBeDeletedSession?._id)}
        onClose={cancelDeleteSessionHandler}
        onOk={() => {
          deleteSessionHandler();
        }}
        isLoading={deleteSessionLoading}
        title={`Alert!`}
        message={`Are you sure you want to delete this session?`}
        confirmPassword={Boolean(auth?.userToken)}
        password={confirmPassword}
        setPassword={setConfirmPassword}
      />
    </>
  );
};

export default SessionList;